import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { API } from './constants';

export type Notification = {
	_id: string;
	userId: string;
	title: string;
	message: string;
	type: string;
	category: string;
	read: boolean;
	readAt?: string;
	accountNumber?: string;
	metadata?: Record<string, any>;
	actionUrl?: string;
	icon?: string;
	createdAt: string;
	updatedAt: string;
};

export type NotificationPagination = {
	totalElements: number;
	hasNextPage: boolean;
	nextPage: number;
	previousPage: number;
	lastPage: number;
};

export type NotificationsResponse = {
	elements: Notification[];
	pagination: NotificationPagination;
};

@Injectable({ providedIn: 'root' })
export class NotificationService extends ApiService {
	getMyNotifications(params?: {
		page?: number;
		limit?: number;
		sortBy?: string;
		sortOrder?: string;
		category?: string;
		type?: string;
		read?: boolean;
		accountNumber?: string;
	}) {
		const query = new URLSearchParams();
		if (params?.page) query.set('page', String(params.page));
		if (params?.limit) query.set('limit', String(params.limit));
		if (params?.sortBy) query.set('sortBy', params.sortBy);
		if (params?.sortOrder) query.set('sortOrder', params.sortOrder);
		if (params?.category) query.set('category', params.category);
		if (params?.type) query.set('type', params.type);
		if (params?.read !== undefined) query.set('read', String(params.read));
		if (params?.accountNumber) query.set('accountNumber', params.accountNumber);

		const qs = query.toString();
		const url = `${API.getMyNotifications}${qs ? `?${qs}` : ''}`;
		return this.get<NotificationsResponse>(url);
	}

	getMyUnreadCount(accountNumber?: string) {
		const qs = accountNumber ? `?accountNumber=${accountNumber}` : '';
		return this.get<number>(`${API.getMyUnreadCount}${qs}`);
	}

	markAsRead(id: string) {
		return this.patch<Notification>(`${API.markNotificationAsRead}/${id}/read`);
	}

	markAllAsRead(accountNumber?: string) {
		const qs = accountNumber ? `?accountNumber=${accountNumber}` : '';
		return this.patch<{ modifiedCount: number }>(`${API.markAllMyNotificationsAsRead}${qs}`);
	}

	deleteNotification(id: string) {
		return this.delete<any>(`${API.deleteNotification}/${id}`);
	}
}
